module.exports = __webpack_public_path__ + "static/media/back.9234521b.svg";